(function($) {
    var $tabHighlighter = null;
    var $tabContentsWrapper = null;
    var validator = null;
    var proxyValidator = null;
    var that = this;
    var interval = null;
    var pingTimeout = null;
    const HTTPREDIRECTWAIT_SECONDS = 30;

    let showHstsOnDialog = false;
    let showHstsOffDialog = false;
    
    var enableKeyStoreSection = function(enable) {
        if (!enable) {
            $('#keystoreSection').attr('disabled', 'disabled');
            $('#keystoreType').attr('disabled', 'disabled');
            $('#keystoreLocation').attr('disabled', 'disabled');
            $('#keystorePassword').attr('disabled', 'disabled');
            $('#keystoreKeyringUsername').attr('disabled', 'disabled');
            $('#keystoreKeyringName').attr('disabled', 'disabled');
            $('#keystoreCertificate').attr('disabled', 'disabled');
            $('#authenticationType').attr('disabled', 'disabled');
            $('#requireAuthCheckbox').attr('disabled', 'disabled');    
            $inputs = $('#keystoreSection input');
            $inputs.removeClass('error');
            $inputs.removeClass('errorborder');
        } else {
            $('#keystoreSection').removeAttr('disabled');
            $('#authenticationType').removeAttr('disabled');
            $('#keystoreType').removeAttr('disabled');
            $('#keystoreLocation').removeAttr('disabled');
            $('#keystorePassword').removeAttr('disabled');
            $('#keystoreCertificate').removeAttr('disabled');
			authenticationTypeChanged();     
            keyStoreTypeChanged();
        }
    };
    
    var enableTrustStoreSection = function(enable) {
        var $section = $('#truststoreSection');
        
        if (!enable) {
            $section.attr('disabled', 'disabled');
            $('#truststoreType').attr('disabled', 'disabled');
            $('#truststoreLocation').attr('disabled', 'disabled');
            $('#truststoreKeyringName').attr('disabled', 'disabled');
            $('#truststorePassword').attr('disabled', 'disabled');
            $('#truststoreKeyringUsername').attr('disabled', 'disabled');
            $inputs = $('#truststoreSection input');
            $inputs.removeClass('error');
            $inputs.removeClass('errorborder');
            
            if ($section.is(':visible')) {
                $section.toggle('blind', 250);
            }
        } else {
            $section.removeAttr('disabled');
            $('#truststoreType').removeAttr('disabled');
            $('#truststoreLocation').removeAttr('disabled');
            $('#truststorePassword').removeAttr('disabled');

            trustStoreTypeChanged();
            
            if (!$section.is(':visible')) {
                $section.toggle('blind', 250);
            }
        }
    };
    
    var enableApplyButton = function() {
        var httpChecked = $('#httpCheckbox').is(':checked');
        var httpsChecked = $('#httpsCheckbox').is(':checked');
        
        if (httpChecked || httpsChecked) {
            $('#apply').removeAttr('disabled');
            $.clearStatus();
        } else {
            $('#apply').attr('disabled', 'disabled');
            $.showErrorStatus(noHttpHttpsError);
        }
    };
    
    var httpChanged = function() {
        var checked = $('#httpCheckbox').is(':checked');
        
        if (checked) {
            $('#httpPort').removeAttr('disabled');
        } else {
            $('#httpPort').attr('disabled', 'disabled');
        }
        
        enableApplyButton();
    };
    
    var httpsChanged = function() {
        var checked = $('#httpsCheckbox').is(':checked');
        
        
        if (checked) {
            $('#httpsPort').removeAttr('disabled');
            enableKeyStoreSection(true);
            enableTrustStoreSection($('#authenticationType').val() === 'TRUSTSTORE');
        } else {
            $('#httpsPort').attr('disabled', 'disabled');
            enableKeyStoreSection(false);
            enableTrustStoreSection(false);
        }
        $('#hstsContainer input')[checked ? 'removeAttr' : 'attr']('disabled', 'disabled');
        enableApplyButton();
    };
    
    var authenticationTypeChanged = function() {
        enableTrustStoreSection($('#authenticationType').val() === 'TRUSTSTORE');
        if ($('#authenticationType').val() === 'NONE'){
        	$('#requireAuthCheckbox').prop('checked', false);
            $('#requireAuthCheckbox').attr('disabled', 'disabled');
            $('.require-client-auth-label').attr('disabled', 'disabled');
        } else {
            $('#requireAuthCheckbox').removeAttr('disabled');
            $('.require-client-auth-label').removeAttr('disabled');
        }
    };
    
    var requireAuthChanged = function() {
    	
    };
    
    var keyStoreTypeChanged = function() {
        var $trustStoreType = $('#keystoreType');
        var type = $trustStoreType.val();

        if (type != 'JCERACFKS' && type != 'JCECCARACFKS') {
            $('#keystoreKeyringUsername').removeClass('error');
            $('#keystoreKeyringUsername').removeClass('errorborder');
            $('#keystoreKeyringUsername').attr('disabled', 'disabled');
            $('#keystoreKeyringUsername').val('');
 
            $('#keystoreKeyringName').removeClass('error');
            $('#keystoreKeyringName').removeClass('errorborder');
            $('#keystoreKeyringName').attr('disabled', 'disabled');
            $('#keystoreKeyringName').val('');
            
            $('#keystoreLocation').removeClass('error');
            $('#keystoreLocation').removeClass('errorborder');
            $('#keystoreLocation').removeAttr('disabled', 'disabled');
            
            $('#keystorePassword').removeAttr('disabled', 'disabled');
        } else {
            $('#keystoreKeyringUsername').removeAttr('disabled');
            $('#keystoreKeyringName').removeAttr('disabled');

            $('#keystoreLocation').val('')
            $('#keystoreLocation').removeClass('error');
            $('#keystoreLocation').removeClass('errorborder');
            $('#keystoreLocation').attr('disabled', 'disabled');
            
            $('#keystorePassword').removeClass('error');
            $('#keystorePassword').removeClass('errorborder');        
            $('#keystorePassword').attr('disabled', 'disabled');
        }
        
        $trustStoreType.removeClass('error');
        $trustStoreType.removeClass('errorborder');
        $.clearStatus();

    };
    
    var trustStoreTypeChanged = function() {
	    var $trustStoreType = $('#truststoreType');
	    var type = $trustStoreType.val();
	
	    if (type != 'JCERACFKS' && type != 'JCECCARACFKS') {
            $('#truststoreKeyringUsername').removeClass('error');
            $('#truststoreKeyringUsername').removeClass('errorborder');
            $('#truststoreKeyringUsername').attr('disabled', 'disabled');
            $('#truststoreKeyringUsername').val('');
 
            $('#truststoreKeyringName').removeClass('error');
            $('#truststoreKeyringName').removeClass('errorborder');
            $('#truststoreKeyringName').attr('disabled', 'disabled');
            $('#truststoreKeyringName').val('');
            
            $('#truststoreLocation').removeClass('error');
            $('#truststoreLocation').removeClass('errorborder');
            $('#truststoreLocation').removeAttr('disabled', 'disabled');
            
            $('#truststorePassword').removeAttr('disabled', 'disabled');
        } else {
            $('#truststoreKeyringUsername').removeAttr('disabled');
            $('#truststoreKeyringName').removeAttr('disabled');

            $('#truststoreLocation').val('')
            $('#truststoreLocation').removeClass('error');
            $('#truststoreLocation').removeClass('errorborder');
            $('#truststoreLocation').attr('disabled', 'disabled');
            
            $('#truststorePassword').removeClass('error');
            $('#truststorePassword').removeClass('errorborder');        
            $('#truststorePassword').attr('disabled', 'disabled');
        }
    };
    
    var keyStoreTypeChanged = function() {
        var $trustStoreType = $('#keystoreType');
        var type = $trustStoreType.val();

        if (type != 'JCERACFKS' && type != 'JCECCARACFKS') {
            $('#keystoreKeyringUsername').removeClass('error');
            $('#keystoreKeyringUsername').removeClass('errorborder');
            $('#keystoreKeyringUsername').attr('disabled', 'disabled');
            $('#keystoreKeyringUsername').val('');
 
            $('#keystoreKeyringName').removeClass('error');
            $('#keystoreKeyringName').removeClass('errorborder');
            $('#keystoreKeyringName').attr('disabled', 'disabled');
            $('#keystoreKeyringName').val('');
            
            $('#keystoreLocation').removeClass('error');
            $('#keystoreLocation').removeClass('errorborder');
            $('#keystoreLocation').removeAttr('disabled', 'disabled');
            
            $('#keystorePassword').removeAttr('disabled', 'disabled');
        } else {
            $('#keystoreKeyringUsername').removeAttr('disabled');
            $('#keystoreKeyringName').removeAttr('disabled');

            $('#keystoreLocation').val('')
            $('#keystoreLocation').removeClass('error');
            $('#keystoreLocation').removeClass('errorborder');
            $('#keystoreLocation').attr('disabled', 'disabled');
            
            $('#keystorePassword').removeClass('error');
            $('#keystorePassword').removeClass('errorborder');        
            $('#keystorePassword').attr('disabled', 'disabled');
        }
        
        $trustStoreType.removeClass('error');
        $trustStoreType.removeClass('errorborder');
        $.clearStatus();

    };
    
    var initialize = function(webServerInfo) {
        if (!!webServerInfo) {
            if (!!webServerInfo.http) {
                if (!!webServerInfo.http.enabled) {
                    $('#httpCheckbox').prop('checked', true);
                } else {
                    $('#httpCheckbox').prop('checked', false);
                }

                if (!webServerInfo.http.port || webServerInfo.http.port < 1) {
                    webServerInfo.http.port = 48080;
                }
                
                $('#httpPort').val(webServerInfo.http.port);
            } else {
                $('#httpCheckbox').prop('checked', true);
                $('#httpPort').val('48080');
            }

            if (!!webServerInfo.https) {
                if (!!webServerInfo.https.enabled) {
                    $('#httpsCheckbox').prop('checked', true);
                    evaluateHSTSContent(webServerInfo.https.strictHttpsEnabled);
                } else {
                    $('#httpsCheckbox').prop('checked', false);
                }

                if (!webServerInfo.https.port || webServerInfo.https.port < 1) {
                    webServerInfo.https.port = 48443;
                }
                
                $('#httpsPort').val(webServerInfo.https.port);
                
                if (!!webServerInfo.https.keystore) {
                    if (!!webServerInfo.https.keystore.type) {
                        $('#keystoreType option[value=' + webServerInfo.https.keystore.type + ']').prop('selected', true);
                    } else {
                        $('#keystoreType option[value="JKS"]').prop('selected', true);
                    }

                    $('#requireAuthCheckbox').prop('checked', webServerInfo.https.keystore.requireClientAuth);
                    $('#keystoreLocation').val(webServerInfo.https.keystore.location);
                    $('#keystorePassword').val('');
                    $('#keystoreKeyringUsername').val(webServerInfo.https.keystore.keyringUser);
                    $('#keystoreKeyringName').val(webServerInfo.https.keystore.keyringName);
                    $('#keystoreCertificate').val(webServerInfo.https.keystore.certificateAlias);
                                         
                    if (!!webServerInfo.https.keystore.authenticationType) {
                        $('#authenticationType option[value=' + webServerInfo.https.keystore.authenticationType + ']').prop('selected', true);
                    } else {
                        $('#authenticationType option[value="NONE"]').prop('selected', true);
                    }
                    
                    if (!!webServerInfo.https.keystore.authenticationType && webServerInfo.https.keystore.authenticationType === 'NONE') {
                        $('.require-client-auth-label').attr('disabled', 'disabled');
            			$('#requireAuthCheckbox').attr('disabled', 'disabled');
                    }
                    
                } else {
                    $('#keystoreType option[value="JKS"]').prop('selected', true);
                    $('#authenticationType option[value="NONE"]').prop('selected', true);
                }
                
                if (!!webServerInfo.https.truststore) {
                    if (!!webServerInfo.https.truststore.type) {
                        $('#truststoreType option[value=' + webServerInfo.https.truststore.type + ']').prop('selected', true);
                    } else {
                        $('#truststoreType option[value="JKS"]').prop('selected', true);
                    }

                    $('#truststoreLocation').val(webServerInfo.https.truststore.location);
                    $('#truststorePassword').val('');
                    $('#truststoreKeyringUsername').val(webServerInfo.https.truststore.keyringUser);
                    $('#truststoreKeyringName').val(webServerInfo.https.truststore.keyringName);
                } else {
                    $('#truststoreType option[value="JKS"]').prop('selected', true);
                }
                
                if (!$('#httpCheckbox').is(':checked') && !$('#httpsCheckbox').is(':checked')) {
                    // one of the protocols have to be checked so initialize to HTTP
                    $('#httpCheckbox').prop('checked', true);
                }
            } else {
                $('#httpsCheckbox').prop('checked', false);
                $('#httpsPort').val('48443');
            }
        } else {
            $('#httpCheckbox').prop('checked', true);
            $('#httpPort').val('48080');
            $('#httpsCheckbox').prop('checked', false);
            $('#httpsPort').val('48443');
        }
        
        httpChanged();
        httpsChanged();
    };
    
    const evaluateHSTSContent = function(hstsSelected) {
		$('#hstsContainer').removeClass('hide');
		$('#hstsCheckbox').prop('checked', hstsSelected);
		initHstsEvents(hstsSelected);
		if (hstsSelected) {
			modifyProtocolForHSTS();
		}
	};
    
    const modifyProtocolForHSTS = function() {
        $('.http-content').addClass('hide');
        $('#httpsCheckboxWrapper').addClass('hide');
    }
    
    const initHstsEvents = function (hstsSelected) {        
        $('#hstsCheckbox').on('change', function() {
            const isChecked = $(this).is(':checked');
            showHstsOnDialog = isChecked && !hstsSelected;
            showHstsOffDialog = !isChecked && hstsSelected;
        });
        
        $('#hstsDialogOn a, #hstsDialogOff a').on('click', function(e) {
            e.preventDefault();
            const url = $(this).attr('href');
            var windowOptions = 'menubar=no,toolbar=yes,status=yes,scrollbars=yes,resizable=yes,width=' + Math.max(screen.availWidth / 2, 400) + ',height=450,top=50,left=250';
            window.open(url, "Compuware Web Help", windowOptions);
        });
    };
    
    const showHstsDialogOn = function() {
        $('#hstsDialogOn').dialog({
            title: hstsDialogTitle,
            width: 520,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
                "OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    click : function() {
                        $.animateCloseDialog('#hstsDialogOn', '#apply');
                        applySettings();
                        $(this).dialog('close');
                        
                    }
                },
                "Cancel" : {
                    text : cancelButtonText,
                    click : function() {                        
                        $.animateCloseDialog('#hstsDialogOn', '#apply');
                        $(this).dialog('close');
                    }
                }
            }
        });
    };
    
    const showHstsDialogOff = function() {
        $('#hstsDialogOff').dialog({
            title: hstsDialogTitle,
            width: 520,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
                "OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    click : function() {
                        $.animateCloseDialog('#hstsDialogOff', '#apply');
                        applySettings();
                        $(this).dialog('close');
                    }
                },
                "Cancel" : {
                    text : cancelButtonText,
                    click : function() {
                        $.animateCloseDialog('#hstsDialogOff', '#apply');
                        $(this).dialog('close');
                    }
                }
            }
        });
    };
    
    var setPingTimeout = function(pingInterval, timeout, serverPrefix, protocol) {
        // after timeout minutes, we give up pinging
        that.pingTimeout = setTimeout(function() {
            $.debugLog('timeout reached, service has not responded');
            clearInterval(pingInterval);
            clearTimeout(that.pingTimeout);
            $.removeLoadingIndicator();
            $('.animated-logo-wrapper').removeClass('restart');
            
            if (location.protocol === 'https:' && protocol === 'http') {
                location.href = serverPrefix + location.pathname + location.search;
            } else {
                $.showMessageDialog({
                    title: restartError, 
                    message: restartTimeoutText
                });
            }
        }, 1000 * timeout);
    };
    
    var pollServer = function(timeout, serverPrefix, protocol, refreshMessage) {
        var pollPromise = null;
        var down = false;
        var gracePeriod = false;
        var progressInterval;
        
        // ping the server every 5 seconds
        var pingInterval = setInterval(function() {
            pollPromise = $.ajax({
                type: 'GET',
                url : serverPrefix + '/compuware/maintenance/ping',
                dataType : 'json',
                cache : false,
                nocache: new Date().getTime()
            })
            
            pollPromise.then(function() {
                // if the request went down previously, and is now back up, we're good
                if (down == true) {  
                    $.debugLog('request succeeded after restart');
                    clearInterval(pingInterval);
                    clearTimeout(that.pingTimeout);
                    let url = `${serverPrefix}${location.pathname}${location.search}`;
                    if (refreshMessage) {
                    	url = `${url}?refreshMessage=${refreshMessage}`;
                    }
                    location.href = url;
                }               
            }, 
            // failed ping callback
            function(err) {  
                $.debugLog('ping failed...');
                // when ping fails, set the down status
                if (!down) {
                    $.debugLog('service has stopped responding...');
                    down = true;
                }
                
                if (err.status == 404 && down && !gracePeriod) {
                    gracePeriod = true;
                    clearTimeout(that.pingTimeout);
                    setPingTimeout(pingInterval, timeout, serverPrefix, protocol);
                    $.debugLog('service has responded with error, extending timeout for OSGi grace period...');
                }
            });
        }, 5000);
        
        setPingTimeout(pingInterval, timeout, serverPrefix, protocol);
    };
    
    var getTestingTimeout = function() {
        var queryString = location.search
        
        var matches = /\?.*timeout=(\d*)&?/i.exec(queryString);
        
        if (matches) {
            return matches[1];
        }
    };
    
    // Check protocol and switches to determine if we need to reload on http instead of https.
	const isHttpForced = function() {
    	const forceHttpFromHttp = location.protocol === 'http:' && $('#httpCheckbox').is(':checked') && !$('#hstsCheckbox').is(':checked');
    	const forceHttpFromHttps = location.protocol === 'https:' && !$('#httpsCheckbox').is(':checked');
    	return  forceHttpFromHttp || forceHttpFromHttps; 
    }
    
    var restart = function() {
        $.when(
            $.getJSON('maintenance/restart', {nocache: new Date().getTime()})
        ).done(function(response) {
            if (response.success == false) {
                $.showErrorStatus(com.compuware.ces.restartFailed);
            } else {
		    	const isForcedHttp = isHttpForced();
				const protocol = isForcedHttp ? 'http' : 'https';                
		        const port = $(isForcedHttp ? '#httpPort' : '#httpsPort').val()
                $.displayLoadingIndicator(restartingText);
                $('.animated-logo-wrapper').addClass('restart');
                if (protocol === 'http' && location.protocol === 'https:') {
					setTimeout(function() {
						location.href = `${protocol}://${location.hostname}:${port}${location.pathname}?refreshMessage=${httpstohttpmessage}`;
			        }, HTTPREDIRECTWAIT_SECONDS * 1000);
                } else {
                	let refreshMessage = '';                
                	if (location.protocol === 'http:' && protocol === 'https') {
                		refreshMessage = httptohttpsmessage;
                	}	
	                pollServer((getTestingTimeout() || 600), `${protocol}://${location.hostname}:${port}`, protocol, refreshMessage);
                }
            }
        });
    };

    var applySettings = function() {
        var webServerInfo = {
            http : {},
            https : {}
        };
        
        if ($('#httpCheckbox').is(':checked')) {
            webServerInfo.http.enabled = true;
            webServerInfo.http.port = $('#httpPort').val();
        } else {
            webServerInfo.http.enabled = false;
        }
        
        if($('#hstsCheckbox').is(':checked')) {
        	webServerInfo.http.enabled = false;
        }
        
        if ($('#httpsCheckbox').is(':checked')) {
            webServerInfo.https.enabled = true;
            webServerInfo.https.port = $('#httpsPort').val();
            webServerInfo.https.strictHttpsEnabled = $('#hstsCheckbox').is(':checked');
            webServerInfo.https.keystore = {};
            webServerInfo.https.keystore.requireClientAuth = $('#requireAuthCheckbox').is(':checked');
            webServerInfo.https.keystore.type = $('#keystoreType').val();
            
            if (!webServerInfo.https.keystore.type) {
                // not on z/OS so assign the default type
                webServerInfo.https.keystore.type = 'JKS';
            }
            
            webServerInfo.https.keystore.location = $('#keystoreLocation').val();
            
            var encryptedKeystorePassword = Crypto.encrypt($('#keystorePassword').val());
            webServerInfo.https.keystore.pwa = encryptedKeystorePassword.iv;
            webServerInfo.https.keystore.pwb = encryptedKeystorePassword.encrypted;
            
            if (webServerInfo.https.keystore.type !== 'JKS') {
                webServerInfo.https.keystore.keyringUser = $('#keystoreKeyringUsername').val();
                webServerInfo.https.keystore.keyringName = $('#keystoreKeyringName').val();
            }
            
            webServerInfo.https.keystore.certificateAlias = $('#keystoreCertificate').val();
            webServerInfo.https.keystore.authenticationType = $('#authenticationType').val();
            
            if (webServerInfo.https.keystore.authenticationType === 'TRUSTSTORE') {
                webServerInfo.https.truststore = {};
                webServerInfo.https.truststore.type = $('#truststoreType').val();

                if (!webServerInfo.https.truststore.type) {
                    // not on z/OS so assign the default type
                    webServerInfo.https.truststore.type = 'JKS';
                }
                
                webServerInfo.https.truststore.location = $('#truststoreLocation').val();
                var trustStorePassword = $('#truststorePassword').val();
                
                if (trustStorePassword != null && trustStorePassword.length > 0) {
                    var encryptedTruststorePassword = Crypto.encrypt(trustStorePassword);
                    webServerInfo.https.truststore.pwa = encryptedTruststorePassword.iv;
                    webServerInfo.https.truststore.pwb = encryptedTruststorePassword.encrypted;
                }
                
                if (webServerInfo.https.truststore.type !== 'JKS') {
                    webServerInfo.https.truststore.keyringUser = $('#truststoreKeyringUsername').val();
                    webServerInfo.https.truststore.keyringName = $('#truststoreKeyringName').val();
                }
            }
        } else {
            webServerInfo.https.enabled = false;
        }

        $.displayLoadingIndicator(savingText, '.form-contents');
        
        $.when(
            $.ajax({
                type: 'POST',
                url : '/compuware/ws/httpconfig',
                contentType : 'application/json',
                dataType : 'json',
                data : JSON.stringify(webServerInfo),
                cache : false,
                nocache: new Date().getTime()
            })
        ).done(function(response) {
            restart();
        }).fail(function(xhr, status, error) {
            if (!!xhr && !!xhr.responseJSON) {
                var response = xhr.responseJSON;
                var errors = response.errors;
                
                if ($.isArray(errors)) {
                    errors = errors[0];
                }
                
                var message = errors.message;
                var elements = [];
                
                if (message === httpPortError) {
                	elements.push('#httpPort');
                } else if (message === httpsPortError) {
                	elements.push('#httpsPort');
                } else if (message === keystoreTypeError) {
                	elements.push('#keystoreType');
                } else if (message === keystoreFileError || message === keystoreFormatError) {
                	if ($('#keystoreType').val() === 'JCERACFKS' || $('#keystoreType').val() === 'JCECCARACFKS'){
                		elements.push('#keystoreKeyringUsername');
                		elements.push('#keystoreKeyringName');
                	}else{
                		elements.push('#keystoreLocation');
                	}                		
                } else if (message === keystorePasswordError) {
                	elements.push('#keystorePassword');
                } else if (message === keystoreCertificateError) {
                	elements.push('#keystoreCertificate');
                } else if (message === truststoreFileError || message === truststoreFormatError) {
                	if ($('#truststoreType').val() === 'JCERACFKS' || $('#keystoreType').val() === 'JCECCARACFKS'){
                		elements.push('#truststoreKeyringUsername');
                		elements.push('#truststoreKeyringName');
                	}else{
                		elements.push('#truststoreLocation');
                	}                         
                } else if (message === truststorePasswordError) {
                	elements.push('#truststorePassword');
                }
                
                if (elements !== null) {
                	
                	elements.forEach(function(e){
                        $element = $(e);
                        $element.addClass('error');
                        $element.addClass('errorborder');
                        $('#webServerTab').addClass("error");
                        $.showErrorStatus(message);
                	});
                }
            }
        }).always(function() {
            $.removeLoadingIndicator();
            evaluateHSTSContent();
        });
    };
    
    var showRestartDialog = function() {
        $('#restartDialog').dialog({
            title: restartTitle,
            width: 500,
            modal: true,
            draggable : false,
            resizable : false,
            buttons : {
                "OK" : {
                    text : okButtonText,
                    'class' : 'ok-button',
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#apply');
                        applySettings();
                        $(this).dialog('close');
                    }
                },
                "Cancel" : {
                    text : cancelButtonText,
                    click : function() {
                        $.animateCloseDialog('#restartDialog', '#apply');
                        $(this).dialog('close');
                    }
                }
            },
            open: function(event, ui) {
                if (location.protocol === 'https:' && !$('#httpsCheckbox').is(':checked')) {
                    $('#restartMessage').append('<br><br>' + restartHttpsText);
                }
                
                $(this).dialog('option', 'position', {my: 'center', at: 'center', of: window});
                $.animateOpenDialog('#restartDialog', '#apply');
            }
        });
    };
    
    var applyHandler = function() {
        $('#webServerTab .initial').removeClass('initial');
        $('#webServerTab .error').removeClass('error');
        $('#webServerTab .errorborder').removeClass('errorborder');
        $('#webServerTab').removeClass("error");
        $.clearStatus();
        var isValid = validator.form();
        
        if (isValid) {
            if (showHstsOnDialog) {
                showHstsDialogOn();
            } else if (showHstsOffDialog) {
                showHstsDialogOff();
            } else {
                showRestartDialog();
            }
        } else {
            validator.invalidElements()[0].focus();
        }
    };
    
    // Proxy 
    
    var toggleProxySection = function(checkbox, elements){
    	if(checkbox.prop('checked')) {
    		elements.removeAttr('disabled');
    	} else {
    		elements.attr({'disabled': 'disabled'});
    		elements.removeClass('error');
    		elements.removeClass('errorborder');
    	}
    	
    	if (!$('#httpProxyCheckbox').prop('checked') && !$('#secureProxyCheckbox').prop('checked')) {
    	    $('#proxyTab').removeClass('error');
    	}
    }
    
    var httpProxyChanged = function() {
    	toggleProxySection($('#httpProxyCheckbox'), $('#httpProxySettingsWrapper input'));
    }
    
    var secureProxyChanged = function() {
    	toggleProxySection($('#secureProxyCheckbox'), $('#secureProxySettingsWrapper input'));
    }
    
    var initializeProxy = function(proxyInfo) {
    	if(!!proxyInfo) {
    		$('#httpProxyCheckbox').prop('checked', proxyInfo.httpProxyEnabled);
    		$('#secureProxyCheckbox').prop('checked', proxyInfo.secureProxyEnabled);
    		
    		if(!!proxyInfo.httpProxy.host) {
    			$('#httpProxyHost').val(proxyInfo.httpProxy.host);
    		}
    		if(!!proxyInfo.httpProxy.port) {
    			var portValue="";
    			if(proxyInfo.httpProxy.port !== "0"){
    				portValue = proxyInfo.httpProxy.port;
    			}
    			$('#httpProxyPort').val(portValue);
    		}
    		if(!!proxyInfo.httpProxy.username) {
    			$('#httpProxyUsername').val(proxyInfo.httpProxy.username);
    		}
    		
    		if(!!proxyInfo.secureProxy.host) {
    			$('#secureProxyHost').val(proxyInfo.secureProxy.host);
    		}
    		if(!!proxyInfo.secureProxy.port) {
    			var portValue="";
    			if(proxyInfo.secureProxy.port !== "0"){
    				portValue = proxyInfo.secureProxy.port;
    			}
    			$('#secureProxyPort').val(portValue);
    		}
    		if(!!proxyInfo.secureProxy.username) {
    			$('#secureProxyUsername').val(proxyInfo.secureProxy.username);
    		}
    		httpProxyChanged();
    		secureProxyChanged();
    	} else {
    		getProxyInfo();
    	}
    }
    
    var packageProxyInfoJson = function(){
    	var proxyInfo = {};
    	proxyInfo.httpProxyEnabled =  $('#httpProxyCheckbox').prop('checked');
    	proxyInfo.secureProxyEnabled =  $('#secureProxyCheckbox').prop('checked');
    	if($('#httpProxyCheckbox').prop('checked')){
    		var httpPw = Crypto.encrypt($('#httpProxyPw').val());
    		proxyInfo.httpProxy = {
				"host" : $('#httpProxyHost').val(),
				"port" : $('#httpProxyPort').val(),
				"username" : $('#httpProxyUsername').val(),
				"pwa" : httpPw.iv,
				"pwb" : httpPw.encrypted
			};
    	}
    	
    	if($('#secureProxyCheckbox').prop('checked')){
    		var securePw = Crypto.encrypt($('#secureProxyPw').val());
    		proxyInfo.secureProxy = {
				"host" : $('#secureProxyHost').val(),
				"port" : $('#secureProxyPort').val(),
				"username" : $('#secureProxyUsername').val(),
				"pwa" : securePw.iv,
				"pwb" : securePw.encrypted
    		};
    	}
    	
    	return proxyInfo;
    }
    
    var getProxyInfo = function() {
		$.when(
	        $.ajax({
	            type: 'GET',
		        url : '/compuware/ws/httpconfig/proxy',
		        dataType : 'json',
		        cache : false,
                nocache: new Date().getTime()
		    })
		).done(function(response) {
			$.debugLog(response);
			if(!!response) {
				initializeProxy(response);
		    } else {
		    	$.showErrorStatus(getProxyError);
		    }
		    
		}).fail(function() {
		}).always(function() {
		    $(window).trigger('proxyLoaded');
		});	
    }
    
    var writeProxyInfo = function() {
    	$.displayLoadingIndicator(savingText, '.proxy-form-contents');
    	var proxyInfo = packageProxyInfoJson();
    	$.debugLog(proxyInfo);
		$.when(
		        $.ajax({
		            type: 'POST',
		        url : '/compuware/ws/httpconfig/proxy',
                contentType : 'application/json',
		        data : JSON.stringify(proxyInfo),
		        dataType : 'json',
		        cache : false,
                nocache: new Date().getTime()
		    })
		).done(function(response) {
		    $.debugLog(response);
		    if(!!response && response.success) {
		    	$.showSuccessStatus(response.message);
		    } else {
		    	$.showErrorStatus(response.message);
		    }
		}).fail(function() {
		}).always(function() {
		    $.removeLoadingIndicator();
		});
    }
    
    var applyProxyHandler = function() {
        $('#proxyTab .initial').removeClass('initial');
        $('#proxyTab .error').removeClass('error');
        $('#proxyTab .errorborder').removeClass('errorborder');
        $('#proxyTab').removeClass("error");
        var isValid = proxyValidator.form();
        
        if (isValid) {
        	writeProxyInfo();
        } else {
            proxyValidator.invalidElements()[0].focus();
        }
    }

    var handleTabClicked = function(event) {
        var $target = $(event.delegateTarget);
        
        if (!$target.attr('disabled') && !$target.hasClass('selected')) {
            var selectedTab = null;
            var targetID = $target.attr('id');
            $('.tab-contents').addClass('selected');
            $('.tab.selected').removeClass('selected');
            $target.addClass('selected');
            
            
            if (targetID === 'webServerTab') {
                $tabHighlighter.animate({left: '0px'}, 500);
                $tabContentsWrapper.stop().animate({left: '0px'}, 500, function() {
                    $('#proxyTabContents').removeClass('selected');
                    $('#portsTabContents').removeClass('selected');
                    $('#emailTabContents').removeClass('selected');
                    $('#loggingTabContents').removeClass('selected');
                    $('#hostHeaderTabContents').removeClass('selected');
                });
                
                selectedTab = 'webServer';
            } else if (targetID === 'proxyTab') {
                $tabHighlighter.animate({left: '154px'}, 500);
                $tabContentsWrapper.stop().animate({left: '-100%'}, 500, function() {
                    $('#webServerTabContents').removeClass('selected');
                    $('#portsTabContents').removeClass('selected');
                    $('#emailTabContents').removeClass('selected');
                    $('#loggingTabContents').removeClass('selected');
                    $('#hostHeaderTabContents').removeClass('selected');
                });
                
                selectedTab = 'proxy';
            } else if (targetID === 'portsTab') {
                $tabHighlighter.animate({left: '308px'}, 500);
                $tabContentsWrapper.stop().animate({left: '-200%'}, 500, function() {
                    $('#proxyTabContents').removeClass('selected');
                    $('#webServerTabContents').removeClass('selected');
                    $('#emailTabContents').removeClass('selected');
                    $('#loggingTabContents').removeClass('selected');
                    $('#hostHeaderTabContents').removeClass('selected');
                });
                
                selectedTab = 'ports';
            } else if (targetID === 'emailTab') {
                $tabHighlighter.animate({left: '462px'}, 500);
                $tabContentsWrapper.stop().animate({left: '-300%'}, 500, function() {
                    $('#proxyTabContents').removeClass('selected');
                    $('#portsTabContents').removeClass('selected');
                    $('#webServerTabContents').removeClass('selected');
                    $('#loggingTabContents').removeClass('selected');
                    $('#hostHeaderTabContents').removeClass('selected');
                });
                
                selectedTab = 'email';
            } else if (targetID === 'loggingTab') {
                $tabHighlighter.animate({left: '616px'}, 500);
                $tabContentsWrapper.stop().animate({left: '-400%'}, 500, function() {
                    $('#proxyTab').removeClass('selected');
                    $('#portsTab').removeClass('selected');
                    $('#emailTab').removeClass('selected');
                    $('#webServerTab').removeClass('selected');
                    $('#hostHeaderTabContents').removeClass('selected');
                });
                
                selectedTab = 'logging';
            
        	} else if (targetID === 'hostHeaderTab') {
        		$tabHighlighter.animate({left: '770px'}, 500);
        		$tabContentsWrapper.stop().animate({left: '-500%'}, 500, function() {
                    $('#proxyTabContents').removeClass('selected');
                    $('#portsTabContents').removeClass('selected');
                    $('#webServerTabContents').removeClass('selected');
                    $('#emailTabContents').removeClass('selected');
        			$('#loggingTabContents').removeClass('selected');
        		});
            
            selectedTab = 'hostHeader';
        	}
        
            if (!!selectedTab && !!history) {
                var selectedTabParameter = 'tab=' + selectedTab;
                var hrefComponents = location.href.split('?');
                var baseURL = hrefComponents[0];
                var queryParameters = hrefComponents[1];
                
                if (!!queryParameters) {
                    var replacedParameter = false;
                    queryParameters = queryParameters.split('&');
                    queryParameters.forEach(function(item, index) {
                        if (item.indexOf('tab=') === 0) {
                            queryParameters[index] = selectedTabParameter;
                            replacedParameter = true;
                        }
                    });
                    
                    if (!replacedParameter) {
                        queryParameters.push(selectedTabParameter);
                    }
                    
                    queryParameters = queryParameters.join('&');
                } else {
                    queryParameters = selectedTabParameter;
                }
                
                history.replaceState({}, $('title')[0].innerHTML, baseURL + '?' + queryParameters);
            }
        }
    };
    
    var handleWindowResize = function() {
        var adjustedHeight = $(window).outerHeight() - $('header').outerHeight() - $('.tabs-container').outerHeight();
        $('.tab-contents').height(adjustedHeight);
    };
    
    var handleSpacebarPress = function(event) {
        if (event.keyCode === 0 || event.keyCode === 32) {
            var $currentTarget = $(event.currentTarget);
            event.preventDefault();
            $currentTarget.click();
        }
    };
    
    var elementRequired = function(element) {
        return !$(element).attr('disabled');
    };
    
    const initHSTSTooltipEvents = function() {
        $('#hstsContainer .hsts-desc-toggle, #hstsContainer .tooltip-arrow, #hstsContainer .desc-tooltip').on('click', function(e) {
            if (!$('#hstsContainer .hsts-desc-toggle').hasClass('open')) {
                $('#hstsContainer .hsts-desc-toggle').addClass('open');
                $('#hstsToolTipWrapper').removeClass('hide');    
            }            
            e.stopImmediatePropagation();
        });
        
        $(document).on('click', function(e) {
           if ($('#hstsContainer .hsts-desc-toggle').hasClass('open')) {
               $('#hstsContainer .hsts-desc-toggle').removeClass('open');
               $('#hstsToolTipWrapper').addClass('hide');
           } 
        });
    }

    const evalRefreshMessage = function() {
    	const params = new URLSearchParams(window.location.search);
    	if (params.has('refreshMessage')) {    		
    		// Adding a 1 second timeout because while page is loading the message is getting cleared.
    		setTimeout(function() {
    			$.showSuccessStatus(decodeURI(params.get('refreshMessage')));
			}, 1000);
    	}
    }

    $(document).ready(function() {
        var itemsLoaded = 0;
        $.displayLoadingIndicator(loadingText);

        $(window).on('webServerLoaded proxyLoaded portsLoaded emailLoaded loggingLoaded hostHeadersLoaded', function() {
            itemsLoaded++;
            
            if (itemsLoaded === 6) {
                $.removeLoadingIndicator();
            }
        });
        
        $tabHighlighter = $('#tabHighlighter');
        $tabContentsWrapper = $('#tabContentsWrapper');
        handleWindowResize();
        $(window).resize(handleWindowResize);
        $('.tab').click(handleTabClicked);
        $('.tab').on('keypress', handleSpacebarPress);
        
        $.validator.addMethod("webServerPortsUnique", function(value, element) {
            return $('#httpPort').val() != $('#httpsPort').val();
        }, portsEqualError);
        
        validator = $('#webServerForm').validate({
            rules: {
                httpPort: {                     
                    required: {
                        depends: function(element) {
                            return $('#httpCheckbox').is(':checked');
                        }
                    },
                    digits : true,
                    webServerPortsUnique : true,
                    min : 1,
                    max : 65535
                },
                httpsPort: {                     
                    required: {
                        depends: function(element) {
                            return $('#httpsCheckbox').is(':checked');
                        }
                    },
                    digits : true,
                    webServerPortsUnique : true,
                    min : 1,
                    max : 65535
                },
                keystoreLocation: {
                    required: true
                },
                keystorePassword: {
                    required: {
                        depends: function(element) {
                            return $('#keystoreType').val() !== 'JCERACFKS' && $('#keystoreType').val() !== 'JCECCARACFKS';
                        }
                    }                
                },
                keystoreKeyringUsername: {
                    required: {
                        depends: function(element) {
                            return $('#keystoreType').val() !== 'JKS';
                        }
                    }
                },
                keystoreKeyringName: {
                    required: {
                        depends: function(element) {
                            return $('#keystoreType').val() !== 'JKS';
                        }
                    }
                },
                keystoreCertificate: {
                    required: false
                },
                truststoreLocation: {
                    required: {
                        depends : function(element) {
                            var httpsEnabled = $('#httpsCheckbox').is(':checked');
                            var useTrustStore = $('#authenticationType').val() === 'TRUSTSTORE';
                            
                            return (httpsEnabled && useTrustStore);
                        }
                    }
                },
                truststorePassword: {
                    required: false 
                },
                truststoreKeyringUsername: {
                    required: {
                        depends: function(element) {
                            var httpsEnabled = $('#httpsCheckbox').is(':checked');
                            var useTrustStore = $('#authenticationType').val() === 'TRUSTSTORE';
                            
                            return (httpsEnabled && useTrustStore && $('#truststoreType').val() !== 'JKS');
                        }
                    }
                },
                truststoreKeyringName: {
                    required: {
                        depends: function(element) {
                            var httpsEnabled = $('#httpsCheckbox').is(':checked');
                            var useTrustStore = $('#authenticationType').val() === 'TRUSTSTORE';
                            
                            return (httpsEnabled && useTrustStore && $('#truststoreType').val() !== 'JKS');
                        }
                    }
                }
            },
            errorPlacement: function (error, element) {
                var $element = $(element);
                $element.removeClass("valid");
                $element.addClass("errorborder");
                $('#webServerTab').addClass('error');
                
                var message = error.html();
                
                if (message && message.length > 0) {
                    $.showErrorStatus(message);
                }
            },
            success : function(success, element) {
                $(element).removeClass('error');
                $(element).removeClass('errorborder');
                
                if (validator.numberOfInvalids() === 0) {
                    $.clearStatus();
                    $('#webServerTab').removeClass('error');
                }
            },
            onfocusin : function(element, event) {
                if (!$(element).hasClass('initial')) {
                    validator.element(element);
                }
                if(!$(element).hasClass('errorborder')){
                	$.clearStatus();
                }
            },
            onfocusout : function(element, event) {
                $(element).removeClass('initial');
                validator.element(element);
            },
            onkeyup : function(element, event) {
                if (event.which !== 9) { // tab key can be ignored because of focus out
                    $(element).removeClass('initial');
                    validator.element(element);
                }
            }
        });
        
        proxyValidator = $('#proxyForm').validate({
            rules: {
            	httpProxyHost: {                     
                    required: {
                        depends: elementRequired
                    }
                },
                httpProxyPort: {                     
                    required: {
                        depends: elementRequired
                    },
                    digits : true,
                    min : 1,
                    max : 65535
                },
                httpProxyUsername: {                     
                    required: {
                    	depends: function(element) {
                    		return elementRequired(element) && $('#httpProxyPw').val().length > 0;
                    	}
                    }
                },
                httpProxyPw: {                     
                    required: {
                    	depends: function(element) {
                    		return elementRequired(element) && $('#httpProxyUsername').val().length > 0;
                    	}
                    }
                },
                secureProxyHost: {                     
                    required: {
                        depends: elementRequired
                    }
                },
                secureProxyPort: {                     
                    required: {
                        depends: elementRequired
                    },
                    digits : true,
                    min : 1,
                    max : 65535
                },
                secureProxyUsername: {                     
                	required: {
                    	depends: function(element) {
                    		return elementRequired(element) && $('#secureProxyPw').val().length > 0;
                    	}
                    }
                },
                secureProxyPw: {                     
                	required: {
                    	depends: function(element) {
                    		return elementRequired(element) && $('#secureProxyUsername').val().length > 0;
                    	}
                    }
                }
            },
            errorPlacement: function (error, element) {
                var $element = $(element);
                $element.removeClass("valid");
                $element.addClass("errorborder");
                $('#proxyTab').addClass('error');
                
                var message = error.html();
                
                if (message && message.length > 0) {
                    $.showErrorStatus(message);
                }
            },
            success : function(success, element) {
                $(element).removeClass('error');
                $(element).removeClass('errorborder');
                
                if (proxyValidator.numberOfInvalids() === 0) {
                    $.clearStatus();
                    $('#proxyTab').removeClass('error');
                }
            },
            onfocusin : function(element, event) {
                if (!$(element).hasClass('initial')) {
                	proxyValidator.element(element);
                }
                
                if(!$(element).hasClass('errorborder')){
                    $.clearStatus();
                }
            },
            onfocusout : function(element, event) {
                $(element).removeClass('initial');
                proxyValidator.element(element);
            },
            onkeyup : function(element, event) {
                if (event.which !== 9) { // tab key can be ignored because of focus out
                    $(element).removeClass('initial');
                    proxyValidator.element(element);
                }
            }
        });
        
        $.when(
            $.ajax({
                type: 'GET',
                url : '/compuware/ws/httpconfig',
                dataType : 'json',
                cache : false,
                nocache: new Date().getTime()
            })
        ).done(function(response) {
            initialize(response);
        }).fail(function() {
        }).always(function() {
            $(window).trigger('webServerLoaded');
            evalRefreshMessage();
        });
        
        initializeProxy();
        
        $('#webServerTabContents').addClass('selected');
        var selectedTab = getQuery('tab');
        
        if (!!selectedTab) {
            $('#' + selectedTab + 'Tab').click();
        }
        
        $('#httpCheckbox').on('change', httpChanged);
        $('#httpsCheckbox').on('change', httpsChanged);
        $('#keystoreType').on('change', keyStoreTypeChanged);
        $('#authenticationType').on('change', authenticationTypeChanged);
        $('#truststoreType').on('change', trustStoreTypeChanged);
        $('#apply').on('click', applyHandler);
        $('#httpProxyCheckbox').on('change', httpProxyChanged);
        $('#secureProxyCheckbox').on('change', secureProxyChanged);
        $('#applyProxy').on('click', applyProxyHandler);
        $("html").on("click", function(event) {
            var clearStatusMessage = true;
            
            if (!!event && !!event.target) {
                var id = $(event.target).attr('id');
                
                if (!!id && id.indexOf('apply') === 0) {
                    clearStatusMessage = false;
                }
            }
            
            if (clearStatusMessage) {
                $.clearStatus();
            }
        });        
        initHSTSTooltipEvents();        
    });    
})(jQuery);